import { Ref, isRef, ref } from 'vue';

export type MaybeRef<T> = T | Ref<T>;

export const maybeUnref = <T>(maybeRef: MaybeRef<T> | undefined, nullishFallback = null) => {
  return isRef(maybeRef) ? maybeRef : ref<T | null>(maybeRef ?? nullishFallback);
};

export const refValueIsDefined = <T>(r: Ref<T | undefined>): r is Ref<T> => {
  return !!r.value;
};
